import { API } from '../config/apiBase';

/**
 * Curtir/descurtir uma oferta na rota oficial do backend: PUT /api/deals/{id}/like.
 *
 * Até 2026-09-14 a página chamava /api/produtos/{id}/like, que não existe (os aliases
 * /produtos são só leitura). A resposta de erro não trazia `liked` e o contador caía 1.
 *
 * Devolve:
 *   { estado: 'login' }                        visitante anônimo ou sessão vencida (401)
 *   { estado: 'ok', curtido, delta: +1 | -1 }  o backend confirmou
 *   { estado: 'erro' }                         qualquer outra resposta ou falha de rede
 * Só `ok` pode mexer no contador ou virar sinal para a inteligência.
 */
export async function alternarCurtida({ dealId, autenticado, token, fetchImpl = fetch }) {
    if (!autenticado) return { estado: 'login' };
    let resposta;
    try {
        resposta = await fetchImpl(`${API}/deals/${encodeURIComponent(dealId)}/like`, {
            method: 'PUT',
            credentials: 'include',
            headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
    } catch (_) {
        return { estado: 'erro' };
    }
    if (resposta.status === 401) return { estado: 'login' };
    let corpo = null;
    try { corpo = await resposta.json(); } catch (_) { corpo = null; }
    if (!resposta.ok || typeof corpo?.liked !== 'boolean') return { estado: 'erro' };
    return { estado: 'ok', curtido: corpo.liked, delta: corpo.liked ? 1 : -1 };
}
